import { useNavigate } from "react-router-dom"

import { ThemeProvider } from "@mui/material"

import {
  customTheme,
  MetricGoalsHeaderMid,
  MetricHeaderLeft,
  MetricHeaderRight,
} from "./Atom"

import { DropdownFilter } from "../../Dropdown"
import { useDispatch, useSelector } from "react-redux"
import {
  setMaevaSelectedGroups,
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedPractices,
  setMaevaSelectedRegions,
  setMetricGoalsSelectedYear,
  setOpportunitySelectedGroupByRole,
  setSelectedMetricGoalsTab,
} from "../../../redux/slices/metricSlice"
import { HeaderInfoNav } from "../Reusable"
import { MetricHeaderWrapper } from "../Atom"

export default function MetricGoalsHeader(props: any) {
  const { name } = props

  const dispatch = useDispatch()

  const navigate = useNavigate()

  // Extract metric state
  const {
    maevaGroups,
    maevaRegions,
    maevaPractices,
    metricGoalsYearList,
    maevaSelectedGroupsNoAll,
    maevaSelectedRegions,
    maevaSelectedPractices,
    metricGoalsSelectedYear,
  } = useSelector((state: any) => state.metric)

  const selectedGroupFilter = maevaSelectedGroupsNoAll?.[0]
  const selectedRegionFilter = maevaSelectedRegions?.[0]
  const selectedPracticeFilter = maevaSelectedPractices?.[0]

  const handleClickBack = (e: any) => {
    navigate(-1)
  }

  const handleGroupFilter = (_: any, value: any) => {
    dispatch(setOpportunitySelectedGroupByRole(value?.props?.value))
    dispatch(setMaevaSelectedGroupsNoAll([value?.props?.value]))

    dispatch(setMaevaSelectedGroups([value?.props?.value]))

    dispatch(
      setMaevaSelectedRegions([{ label: "All", region: "all", name: "all" }]),
    )
    dispatch(
      setMaevaSelectedPractices([
        { label: "All", name: "all", practice_sk: "all" },
      ]),
    )
    dispatch(setMetricGoalsSelectedYear(metricGoalsYearList?.[0]))
    dispatch(setSelectedMetricGoalsTab(0))
  }

  const handleRegionFilter = (_: any, value: any) => {
    dispatch(setMaevaSelectedRegions([value?.props?.value]))
    dispatch(
      setMaevaSelectedPractices([
        { label: "All", name: "all", practice_sk: "all" },
      ]),
    )
  }

  const handlePracticeFilter = (_: any, value: any) => {
    dispatch(setMaevaSelectedPractices([value?.props?.value]))
  }

  const handleYearFilter = (_: any, value: any) => {
    dispatch(setMetricGoalsSelectedYear(value?.props?.value))
  }

  return (
    <>
      <ThemeProvider theme={customTheme}>
        <MetricHeaderWrapper>
          <MetricHeaderLeft>
            <HeaderInfoNav name={name} handleClickBack={handleClickBack} />
          </MetricHeaderLeft>

          <MetricGoalsHeaderMid>
            <DropdownFilter
              id={1}
              disabled={false}
              handleFilter={handleGroupFilter}
              retainedValue={selectedGroupFilter}
              filterData={maevaGroups}
              headerLabel="Group Name"
              selectedGroupFilter={selectedGroupFilter}
            />
            <DropdownFilter
              id={2}
              disabled={!selectedGroupFilter}
              handleFilter={handleRegionFilter}
              retainedValue={selectedRegionFilter}
              filterData={maevaRegions}
              headerLabel="Regions"
            />
            <DropdownFilter
              id={3}
              disabled={!(selectedGroupFilter && selectedRegionFilter)}
              handleFilter={handlePracticeFilter}
              retainedValue={selectedPracticeFilter}
              filterData={maevaPractices}
              headerLabel="Offices"
            />
            <DropdownFilter
              id={4}
              disabled={
                !(
                  selectedGroupFilter &&
                  selectedRegionFilter &&
                  selectedPracticeFilter
                )
              }
              retainedValue={metricGoalsSelectedYear}
              handleFilter={handleYearFilter}
              filterData={metricGoalsYearList}
              headerLabel="Year"
            />
          </MetricGoalsHeaderMid>

          <MetricHeaderRight></MetricHeaderRight>
        </MetricHeaderWrapper>
      </ThemeProvider>
    </>
  )
}
